export default __webpack_public_path__ + "static/media/uaf-africa.fea17c3e.png";